module.exports = __webpack_public_path__ + "static/work01_01-7b1536577f8df6c82c30c86e7b1bb34e.png";